import styled from "styled-components";

export const SearchClaims = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 7px 3px;
`;

export const TermsLink = styled.a`
  color: black;
  font-family: Rubik;
  font-size: 13px;
  font-weight: 300;
  line-height: 1.4;

  cursor: pointer;
  text-decoration: underline;
`;

export const PoweredBy = styled.p`
  color: black;
  font-family: Rubik;
  font-size: 13px;
  font-weight: 300;
  line-height: 1.4;
`;
